var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[(!_vm.loading && _vm.student)?_c('v-col',{attrs:{"cols":"12","md":"8","offset-md":"2"}},[_c('student-form',{attrs:{"isCreateMode":true,"student":_vm.student,"formTitle":_vm.descriptions.register_new_student},on:{"save":_vm.onSave}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }